import gsap from 'gsap'
import ResizeService from '@/services/ResizeService'
import { mapState, mapMutations } from 'vuex'
import OutlineBtn from '@/components/common/OutlineBtn' 
import AnimationConfig from 'src/config/animation'
import { PATHS, HOME, MODAL_STATES } from 'src/config/app' 
import Env from 'src/config/env'

export default {

  computed: {  
    ...mapState('app', [ 'home', 'modal_state', 'motion_clamp' ]) 
  },

  components: {
    OutlineBtn
  },

  data() {
    return {
      show: false,
      dir: 0,
      showStars: false,
      opacityMult: Env.mobile ? 0.9 : 1,
      base_duration: AnimationConfig.home.section.duration
    }
  },

  props: { },

  mounted(){  
    if(this.home.section_index === this.section.index){
      this.show = true
    }
  },

  beforeDestroy() { },

  methods: {

    showButton(){
      const mult = Env.mobile ? 0.85 : 1.1
      const button_delay = this.base_duration * mult
      this.$refs.button.enter(1, button_delay)
    },

    onEnterComplete(){
      const span = this.$refs.title.querySelector('strong')
      span.style.color = '#FFD730'
      this.$refs.title.focus()
    },


    /* modal states */
   
    modalNone(){
      this.update()
    },

    updateModal(){},

    updateRoute(){},

    update(){

      let prev_section = this.home.prev_section
      let current_section = this.home.current_section
      if( prev_section ){
        this.dir = (current_section.index < prev_section.index ) ? -1 : 1  
      } else {
        this.dir = 1
      } 

      if(this.home.mode === HOME.MODES.DEFAULT){
        if(current_section.index === this.section.index){
          this.show = true
        } else  {
          this.show = false 
        } 
      } 
    }  
  },

  watch: {
 
    'home.current_section'(){ 
      this.update() 
    },
 
    $route(val){   
      //this.updateRoute()
      this.update()  
    },
 
    modal_state(val){   
      //this.updateModal() 
      this.update() 
    } 
  }
}